import React from 'react';
import Button from './Button';

const NavigationControls = ({ 
currentStep,
overalStep,
totalSteps,
onPrevious,
onNext,
isNextDisabled = false,
isProcessing = false,
nextButtonText = 'Continue',
previousButtonText = 'Back',
showPrevious = true,
className = '' 
}) => {
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
const isFirstStep = currentStep === 1;
const isLastStep = currentStep === totalSteps;

return (
<div className={`navigation-controls ${isMobile ? 'navigation-controls-mobile' : ''} ${className}`}>
<div className="max-w-5xl mx-auto w-full flex items-center justify-between gap-4">
{showPrevious && overalStep > 1 && overalStep < 7 ? (
<Button
variant="outline"
onClick={onPrevious}
disabled={isProcessing}
iconName="ChevronLeft"
iconPosition="left"
className="min-w-[120px] border border-gray-200"
>
{previousButtonText}
</Button>
) : (
<div />
)}

<div className="flex items-center justify-between gap-4">


<Button
variant="default"
onClick={onNext}
disabled={isNextDisabled || isProcessing}
loading={isProcessing}
iconName={isLastStep ? 'Check' : 'ChevronRight'}
iconPosition="right"
className="min-w-[120px]"
>
{isLastStep ? 'Complete' : nextButtonText}
</Button>


{/*<Button
variant="default"
// onClick={onNext}
disabled={isLastStep || isFirstStep}
loading={isProcessing}
iconName={'Clock'}
iconPosition="left"
className="min-w-[120px] bg-red-500"
>
Continue Later
</Button>*/}

</div>

</div>
</div>
);
};

export default NavigationControls;